import { render, staticRenderFns } from "./sytyggl.vue?vue&type=template&id=6f665f48&"
import script from "./sytyggl.vue?vue&type=script&lang=js&"
export * from "./sytyggl.vue?vue&type=script&lang=js&"
import style0 from "./sytyggl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports